import { useState, useCallback } from 'react';
import { db, auth } from '../firebase/config'; // Config rape
import { cleanPayload } from '../firebase/cleanPayload'; // Ñamopotĩ haguã
import { getNombreOperador } from '../firebase/firebaseUtils'; // ◄ Mba'eapohára réra jejuhu haguã
import { 
    collection, 
    doc, 
    getDocs, 
    deleteDoc, 
    updateDoc, 
    writeBatch, 
    serverTimestamp,
    Timestamp 
} from 'firebase/firestore';

/**
 * useBitacoraTimeline - Hook de Arquitectura Corporativa
 * Centraliza la lógica de CRUD, ordenamiento en memoria y guardado transaccional en lote
 * de observaciones, bitácoras de siniestros, etapas de postventa y seguimientos comerciales.
 * * @param {string|object} options - Kuatia jehai mbohavara ('comentario' térã 'observacion')
 */
export const useBitacoraTimeline = (options = 'observacion') => {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [deletions, setDeletions] = useState([]); // Mbogue pytyvõra haguã

    const dbField = typeof options === 'string' ? options : (options?.dbField || 'observacion');

    /**
     * fetchNotes - Carga las notas de la subcolección correspondiente y las ordena en memoria.
     */
    const fetchNotes = useCallback(async (subcollectionPath) => {
        if (!subcollectionPath) return;
        setLoading(true);
        try {
            const snap = await getDocs(collection(db, subcollectionPath));
            const rawList = snap.docs.map(d => {
                const data = d.data();
                let fCreacion = data.fechaCreacion;
                
                if (fCreacion?.seconds) {
                    fCreacion = new Date(fCreacion.seconds * 1000).toISOString();
                } else if (fCreacion instanceof Date) {
                    fCreacion = fCreacion.toISOString();
                } else if (!fCreacion) {
                    fCreacion = new Date().toISOString();
                }
                
                const notaTexto = data.comentario || data.observacion || '';
                const tipoAccion = data.tipoGestion || data.tipo || '';

                return {
                    id: d.id,
                    ...data,
                    comentario: notaTexto,
                    observacion: notaTexto,
                    tipo: tipoAccion,
                    tipoGestion: tipoAccion,
                    fechaCreacion: fCreacion,
                    isFromDB: true
                };
            });

            const sortedList = rawList.sort((a, b) => b.fechaCreacion.localeCompare(a.fechaCreacion));
            setItems(sortedList);
        } catch (error) {
            console.error("Javy oñembyatývo kuatiakuéra:", error);
        } finally {
            setLoading(false);
        }
    }, []);

    /**
     * addLocalNote - Mboguapy pyahu arapypegua
     */
    const addLocalNote = useCallback((tipo, comentario, extraFields = {}) => {
        const now = new Date();
        const tempNote = {
            id: `temp-${Date.now()}`,
            localId: Date.now(),
            tipo: tipo || '',
            tipoGestion: tipo || '', 
            comentario: comentario || '',
            observacion: comentario || '', 
            fechaCreacion: now.toISOString(),
            isNew: true,
            ...extraFields
        };
        setItems(prev => [tempNote, ...prev]);
    }, []);

    /**
     * updateLocalNote - Moambue arapypegua oĩva herape
     */
    const updateLocalNote = useCallback((id, tipo, comentario, extraFields = {}) => {
        setItems(prev => prev.map(item => {
            if (item.id === id || item.localId === id) {
                return {
                    ...item,
                    tipo: tipo || item.tipo,
                    tipoGestion: tipo || item.tipoGestion, 
                    comentario: comentario !== undefined ? comentario : item.comentario,
                    observacion: comentario !== undefined ? comentario : item.observacion, 
                    isModified: true,
                    ...extraFields
                };
            }
            return item;
        }));
        setEditingId(null);
    }, []);

    /**
     * removeLocalNote - Mbogue kuatiakuéra herape
     */
    const removeLocalNote = useCallback(async (id, immediateDeleteColPath = null) => {
        const item = items.find(x => x.id === id || x.localId === id);
        
        if (!item) return;

        if (item.isFromDB && immediateDeleteColPath) {
            try {
                const docRef = doc(db, immediateDeleteColPath, id);
                await deleteDoc(docRef);
            } catch (error) {
                console.error("Javy mborépe:", error);
                return;
            }
        } 
        else if (item.isFromDB) {
            setDeletions(prev => [...prev, id]);
        }

        setItems(prev => prev.filter(x => x.id !== id && x.localId !== id));
        if (editingId === id) setEditingId(null);
    }, [items, editingId]);

    /**
     * persistBatchChanges - Ñongatu masiva Batch rupive
     */
    const persistBatchChanges = useCallback(async (subcollectionPath, operatorName) => {
        if (!subcollectionPath) return;
        const batch = writeBatch(db);
        const colRef = collection(db, subcollectionPath);

        // 1. Mbogue oñembyatýva
        deletions.forEach(idToDel => {
            batch.delete(doc(db, subcollectionPath, idToDel));
        });

        // 2. Mboguapy pyahu ha moambue
        items.forEach(item => {
            const fCreacionDB = Timestamp.fromDate(new Date(item.fechaCreacion));
            const textoNota = item.comentario || item.observacion || '';
            const tipoNota = item.tipoGestion || item.tipo || '';

            // ◄ ÑAMBOHOVÁI: Mba'eapohára réra jejuhu ha ñangareko mbytegua
            let finalOperatorName = operatorName;
            if (!finalOperatorName) {
                try {
                    finalOperatorName = getNombreOperador();
                } catch (e) {
                    console.error("Javy mba'eapohára réra jejuhúpe:", e);
                }
            }
            if (!finalOperatorName) finalOperatorName = 'SISTEMA';

            // Ñamopu'ã ñongatupy rupa
            const basePayload = {
                ...item,
                tipoGestion: tipoNota, 
                [dbField]: textoNota,  
                fechaCreacion: fCreacionDB,
                usuarioId: auth.currentUser?.uid || 'SISTEMA',
                usuarioNombre: finalOperatorName,
                ultimaModificacion: serverTimestamp()
            };

            // Potĩmby reko React-pe g̃uarã
            delete basePayload.id;
            delete basePayload.localId;
            delete basePayload.isNew;
            delete basePayload.isModified;
            delete basePayload.isFromDB;
            
            // ◄ ANI OJEHU JO'APY
            delete basePayload.tipo; 
            
            if (dbField === 'observacion') {
                delete basePayload.comentario;
            } else if (dbField === 'comentario') {
                delete basePayload.observacion;
            }

            // Ñamopotĩ kuatiarypy
            const cleanedData = cleanPayload(basePayload);

            if (item.isNew) {
                const newDocRef = doc(colRef);
                batch.set(newDocRef, cleanedData);
            } else if (item.isModified) {
                const existingRef = doc(db, subcollectionPath, item.id);
                batch.update(existingRef, cleanedData);
            }
        });

        await batch.commit();
        setDeletions([]);
    }, [items, deletions, dbField]);

    const resetBitacora = useCallback(() => {
        setItems([]);
        setDeletions([]);
        setEditingId(null);
        setLoading(false);
    }, []);

    return {
        items,
        loading,
        editingId,
        setEditingId,
        fetchNotes,
        addLocalNote,
        updateLocalNote,
        removeLocalNote,
        persistBatchChanges,
        resetBitacora
    };
};